// @flow
import { chunk, groupBy } from 'lodash';
import type {
  Airing,
  MovieAndShow,
  Page,
  SearchAutoCompletion,
  SearchResultsGroupT,
} from './types';
import type { Recording } from '../dvr/types';

import { PAGE_SIZE } from './actions';

export const generateDvrPages = (
  content: Array<Recording>,
  pageSize?: number = PAGE_SIZE,
): Array<Page<Recording>> => {
  if (content.length === 0) {
    /* Return single page with no content if dvr search has returned no results */
    return [{ id: 0, fetching: false, error: false, content: [] }];
  }

  const chunks = chunk(content, pageSize);
  return chunks.map((chunk, id) => ({
    id,
    fetching: false,
    error: false,
    content: chunk,
  }));
};

export const filterDvrRecordingsBySearchKeyword = (
  entries: Array<Recording>,
  keyword: string,
): Array<Recording> => {
  const lowerCasedKeyWord = keyword.toLocaleLowerCase(); // This is to improve accuracy
  return entries.filter(e => e.name.toLocaleLowerCase().includes(lowerCasedKeyWord));
};

export const replaceHttpLinkWithHttpsDvrEntries = (entries: Array<Recording>) => {
  entries.forEach(entry => {
    if (entry.image) entry.image = entry.image.replace('http://', 'https://');
  });
};

export const replaceHttpLinkWithHttpsAirings = (entries: Array<Airing>) => {
  entries.forEach(entry => {
    if (entry.images.poster_url) {
      entry.images.poster_url = entry.images.poster_url.replace('http://', 'https://');
    }
    if (entry.images.wide_poster_url) {
      entry.images.wide_poster_url = entry.images.wide_poster_url.replace('http://', 'https://');
    }
  });
};

export const replaceHttpLinkWithHttpsMoviesAndShows = (entries: Array<MovieAndShow>) => {
  entries.forEach(entry => {
    if (entry.thumbnailUrl) {
      entry.thumbnailUrl = entry.thumbnailUrl.replace('http://', 'https://');
    }
  });
};

export const generateSortedSearchResultsGroups = (
  autoCompletions: Array<SearchAutoCompletion>,
): Array<SearchResultsGroupT> => {
  const groupedByType = groupBy(autoCompletions, (i: SearchAutoCompletion) => i.type);

  return [
    { title: 'shows', content: groupedByType.shows || [], linkPrefix: 'franchise' },
    { title: 'movies', content: groupedByType.movies || [], linkPrefix: 'franchise' },
    { title: 'people', content: groupedByType.actors || [], linkPrefix: 'celebrities' },
    { title: 'networks', content: groupedByType.networks || [], linkPrefix: 'networks' },
    { title: 'sports', content: groupedByType.teams || [], linkPrefix: 'team' },
  ].filter(autocompletionGroup => autocompletionGroup.content.length > 0);
};
